import React, { useState } from 'react';
import MouseLightEffect from './MouseLightEffect';
import PorcentajeBateriaInput from './PorcentajeBateriaInput';
import { useTrack } from '../analytics/TrackingContext';

function TiempoCargando({ capacidadBateria }) {
  const { trackEvent } = useTrack();
  const [porcentajeCarga, setPorcentajeCarga] = useState('');
  const [potenciaCarga, setPotenciaCarga] = useState('');
  const [resultado, setResultado] = useState(null);
  const [animarResultado, setAnimarResultado] = useState(false); 
  const [errorMessage, setErrorMessage] = useState('');
  const [showInfo, setShowInfo] = useState(false);

  const calcularTiempo = () => {
    if (!porcentajeCarga || !potenciaCarga) {
      setErrorMessage('Por favor, introduce todos los datos.');
      setResultado(null);
      return;
    }
    if (!capacidadBateria || parseFloat(capacidadBateria) <= 0) {
      setErrorMessage('Introduce la capacidad de la batería en el campo superior.');
      setResultado(null);
      return;
    }

    const kWhACargar = (parseFloat(porcentajeCarga) / 100) * parseFloat(capacidadBateria);
    const tiempoDecimal = kWhACargar / parseFloat(potenciaCarga);
    const horas = Math.floor(tiempoDecimal);
    const minutos = Math.round((tiempoDecimal - horas) * 60);

    setResultado({ horas, minutos, kWh: kWhACargar.toFixed(2) });
    setAnimarResultado(true);
    setErrorMessage('');
    trackEvent('calculation', 'tiempo_cargando');
  };

  return (
    <MouseLightEffect>
    <div className="section-container">

      <div className="tooltip-wrapper" style={{ position: 'absolute', top: '12px', right: '12px' }}>
        <button
          onClick={() => setShowInfo(true)}
          aria-label="Más información"
          style={{ background: 'transparent', border: '1px solid #ccc', borderRadius: '50%', width: '28px', height: '28px', cursor: 'pointer', fontSize: '1rem', lineHeight: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Kiafontl' }}
        >ℹ</button>
        <span className="tooltip-text tooltip-left">Más información</span>
      </div>

      <h2 style={{ textAlign: 'center', width: '100%' }}>¿Cuánto tiempo tardo en cargar?</h2>

      {showInfo ? (
        <div className="info-panel">
          <p>Calcula cuánto tiempo tardarás en cargar la batería. Introduce la cantidad de kWh que necesitas recuperar y la potencia del cargador disponible. El resultado se muestra en horas y minutos.</p>
          <div className="button">
            <button className="calc" onClick={() => setShowInfo(false)}>← Volver</button>
          </div>
        </div>
      ) : (
        <>
          <PorcentajeBateriaInput
            id="pct_tiempo"
            label="% Batería a Cargar:"
            value={porcentajeCarga}
            onChange={setPorcentajeCarga}
          />
      
      <div className="input">
        <label htmlFor="pot_input">Potencia de Carga (kW): </label>
        <input
          id="pot_input"
          type="number"
          value={potenciaCarga}
          onChange={(e) => setPotenciaCarga(e.target.value)}
          placeholder="Ej: 7.5"
          min={0}
        />
      </div>

      <div className="button">
        <button className="calc" onClick={calcularTiempo}>Calcular Tiempo</button>
      </div>

      {errorMessage && (
          <div className="error-message" role="alert" aria-live="assertive">
          <p>{errorMessage}</p>
        </div>
      )}

      {resultado !== null && (
          <div className={`res ${animarResultado ? 'resultado-animado' : ''}`} aria-live="polite" aria-atomic="true">
          <p>¿Cuánto tiempo tardo en cargar?</p>
          <p><strong>{resultado.horas} horas y {resultado.minutos} minutos</strong></p>
          <p style={{ fontSize: '0.85rem', opacity: 0.7 }}>(el {porcentajeCarga}% representa {resultado.kWh} kWh en esta batería)</p>
          <div className="icon-container">
            <img 
              src={`${process.env.PUBLIC_URL}/images/TiempoCargando01.png`} 
              alt="Icono de Tiempo" 
              className="icono-tiempo-cargando" 
            />
          </div>
        </div>
      )}
        </>
      )}
    </div>
    </MouseLightEffect>
  );
}

export default TiempoCargando;

